function stringToColor(string) {
    return 'primary.main';
}

function stringToDisplay(string) {
    if (!string) {
        return ``;
    }
    let splits = string.split(' ');
    let result = splits.length === 1 ? `${splits[0][0]}` : `${splits[0][0]}${splits[1][0]}`;
    return result.toUpperCase();
}

export { stringToColor, stringToDisplay };
